import { useDesignContext } from '@systemeio/digital-store-shared'
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { SecondaryButton } from '@systemeio/ui'
import { StoreFontPicker } from 'modules/stores/store/components/design/store-font-picker'
import PreviewBox from 'modules/stores/store/components/preview-box'
import React, { Fragment, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { useStore } from '../hooks/use-store'
import { useStoreQuery } from '../hooks/use-store-query'
import { StoreThemeColorPicker } from './design/store-theme-color-picker'
import { StoreThemeSaveButton } from './design/store-theme-save-button'
import { EyeIcon } from '@systemeio/ui/icons'

const PreviewBoxMobile = ({
  title,
  icon,
  className,
  showOnlyCloseButton = false,
}: {
  title?: string
  icon?: React.ReactNode
  className?: string
  showOnlyCloseButton?: boolean
}) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)

  const { storeId } = useStoreQuery()

  const { data: store } = useStore(storeId)

  const { setState } = useDesignContext()

  const afterLeave = () => {
    store && setState(store.design)
  }

  const handleClose = () => {
    setOpened(false)
  }

  return (
    <>
      <SecondaryButton
        className={twMerge('flex lg:hidden', className)}
        onClick={() => setOpened(!opened)}
      >
        {icon === undefined && (
          <EyeIcon
            className={
              'fill-text-primary group-hover:fill-background-secondary main-transition-colors'
            }
          />
        )}
        {icon}
        {title}
      </SecondaryButton>
      <Transition appear show={opened} as={Fragment} afterLeave={afterLeave}>
        <Dialog as="div" className="relative z-50" onClose={handleClose}>
          <TransitionChild
            as={Fragment}
            enter="duration-300 ease-out"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-200 ease-in"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </TransitionChild>
          <div className="fixed inset-x-0 bottom-0 h-full">
            <div className="flex h-full min-h-full items-center justify-center text-center">
              <TransitionChild
                as={Fragment}
                enter="transition duration-300 ease-in-out transform"
                enterFrom="transform translate-y-full"
                enterTo="transform translate-y-0"
                leave="transition duration-300 ease-in-out transform"
                leaveFrom="transform translate-y-0"
                leaveTo="transform translate-y-full"
              >
                <DialogPanel className="bg-background-primary flex h-full w-full transform select-none justify-center overflow-hidden p-5 text-left align-middle shadow-xl">
                  <div className="flex h-full w-fit flex-col items-center justify-center gap-3">
                    <PreviewBox />

                    {!showOnlyCloseButton && (
                      <div className={'flex flex-col items-start gap-3'}>
                        <StoreThemeColorPicker />
                        <StoreFontPicker />
                      </div>
                    )}

                    {!showOnlyCloseButton && <StoreThemeSaveButton className="w-full" />}

                    <SecondaryButton className="w-full" onClick={handleClose}>
                      {t('global.close')}
                    </SecondaryButton>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default PreviewBoxMobile
